import { INDENTS } from 'vars/index'

export const Indents = {
  INDENT_10: INDENTS.INDENT_10,
  INDENT_20: INDENTS.INDENT_20,
  INDENT_40: INDENTS.INDENT_40,
} as const
export type Indents = (typeof Indents)[keyof typeof Indents]

export const Direction = {
  Row: 'row',
  Column: 'column',
} as const
export type Direction = (typeof Direction)[keyof typeof Direction]

export const JustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type JustifyContent =
  (typeof JustifyContent)[keyof typeof JustifyContent]
